import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CategoryResponse } from '../../../_models/category';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../global/global.service';
import {
  requiredFileType,
  ResponseStructure,
} from '@iq-central-front-end/share';
import Swal from 'sweetalert2';
import { CourseResponseDTO } from '../../../_models/course';
import { AuthService } from '../../../_services/auth.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'iq-central-front-end-create-course',
  templateUrl: './create-course.component.html',
  styleUrls: ['./create-course.component.scss'],
})
export class CreateCourseComponent implements OnInit, OnDestroy {
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [['bold']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };

  sub: Subscription = new Subscription();
  currentPage = 'create-course';
  selected = '';
  createCourseForm: FormGroup;
  categories: CategoryResponse[] = [];
  subCategories: any[] = [];
  topics: any[] = [];
  userType: any;
  isLoading: boolean;

  topicsObjectArray: any[] = [];
  courseCode: string;
  courseData: CourseResponseDTO;
  fileName: string;
  courseDuration: any;
  selectedTopics: any[] = [];
  isFetching: boolean = false;
  isFetchingSubcategories: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly _course: CourseService,
    private readonly _global: GlobalService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService
  ) {
    this.userType = authService.getUserType();
  }

  ngOnInit(): void {
    this.courseCode = this.activatedRoute.snapshot.paramMap.get('code');

    if (this.courseCode) {
      this.getCourseData();
    }

    this.initCourseForm();
    this.getAllCategories();
  }

  listenToActivatedRoute() {
    this.sub.add(this.activatedRoute.data.subscribe((res) => {}));
  }

  initCourseForm() {
    this.createCourseForm = this.fb.group({
      certificate: [
        this.courseData?.certificateFileUrl ?? null,
        [requiredFileType('pdf')],
      ],
      picture: [
        this.courseData?.imageUrl ?? null,
        [Validators.required, requiredFileType('png', 'jpeg', 'jpg')],
      ],
      id: [this.courseData?.category?.id ?? null],
      category: [this.courseData?.subCategory?.id ?? null],
      topics: [this.selectedTopics],
      description: [this.courseData?.description ?? '', Validators.required],
      duration: [''],
      hasCertificate: [this.courseData?.hasCertificate ?? true],
      level: [this.courseData?.level ?? 'BASIC', Validators.required],
      title: [this.courseData?.title ?? '', Validators.required],
      certificateType: [this.courseData?.certificateType ?? 'GENERIC'],
      courseCode: [this.courseData?.code],
    });
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  getCourseData() {
    this.isFetching = true;

    this.sub.add(
      this._course
        .getCourseById(this.courseCode)
        .pipe(finalize(() => (this.isFetching = false)))
        .subscribe({
          next: (res) => {
            console.log(res);
            this.courseData = res['responseResult'];
            console.log(this.courseData);

            this.getAllSubCategories(this.courseData?.category);
            this.topics = this.courseData['topics'];
            this.topics.forEach((t) => {
              this.selectedTopics.push(t.id);
            });

            this.getFileName(this.courseData.imageUrl);
            // this.parseToDate(this.courseData.duration);

            this.initCourseForm();
          },
        })
    );
  }

  getAllCategories() {
    this.sub.add(
      this._course.getAllCategories().subscribe({
        next: (res) => {
          this.categories = res['responseResult'];
          this.topics = [];
        },
      })
    );
  }

  getAllSubCategories(event: CategoryResponse) {
    this.isFetchingSubcategories = true;

    this.sub.add(
      this._course
        .getAllSubcategories(event.id)
        .pipe(finalize(() => (this.isFetchingSubcategories = false)))
        .subscribe({
          next: (res) => {
            this.subCategories = res['responseResult'];
          },
        })
    );
  }

  getAllTopics(event) {
    this.sub.add(
      this._course.getllTopics(event.id).subscribe({
        next: (res) => {
          this.topics = res['responseResult'];
        },
      })
    );
  }
  finish() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This course will be saved and you will be taken to your courses',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1CB4AE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.value) {
        this._global.showSpinner();
        this.saveCourse();
      }
    });
  }

  addLesson(route: string) {
    if (this.createCourseForm.invalid) {
      this.createCourseForm.markAllAsTouched();
      return;
    }

    this.saveCourse(route);
  }

  saveCourse(route?) {
    console.log(this.createCourseForm.value);
    this.isLoading = true;

    const isUpdate = !!this.courseData;

    if (isUpdate && !this.createCourseForm.dirty) {
      // No changes, just navigate
      this.isLoading = false;
      if (route) {
        this.router.navigate(['courses/edit-lesson', this.courseCode]);
      } else {
        this.router.navigate(['courses/course-details', this.courseCode]);
      }
      return;
    } else {
      this.topicsObject();
    }

    // this.createCourseForm.patchValue({
    //   duration: `${this.createCourseForm.get('duration').value.hour}:${
    //     this.createCourseForm.get('duration').value.minute
    //   }`,
    // });

    const payload = this.createCourseForm.value;
    if (!isUpdate) {
      payload.courseType = 'FREE';
    } else {
      this.createCourseForm.patchValue({ topics: this.topicsObjectArray });
    }

    const courseJson = JSON.stringify(payload);
    const certificate = this.createCourseForm.get('certificate').value;
    const picture = this.createCourseForm.get('picture').value;

    const apiCall = isUpdate
      ? this._course.updateCourse(
          certificate,
          this.courseCode,
          courseJson,
          picture
        )
      : this._course.createCourse(certificate, courseJson, picture);

    this.sub.add(
      apiCall.subscribe({
        next: (res: ResponseStructure) => {
          this.isLoading = false;

          if (!isUpdate) {
            this.courseData = res['responseResult'];
          }

          if (route) {
            this.router.navigate([
              isUpdate ? 'courses/edit-lesson' : 'courses/add-lesson',
              this.courseData['code'],
            ]);
          } else {
            this._global.hideSpinner();
            this.router.navigate([
              isUpdate ? 'courses/course-details' : 'courses',
              isUpdate ? this.courseCode : '',
            ]);
          }
        },
        error: (e) => {
          this.isLoading = false;
          this._global.hideSpinner();
        },
      })
    );
  }

  // parseToDate(duration: string) {
  //   const strArr = duration.split(':');
  //   this.courseDuration = {
  //     hour: parseInt(strArr[0]),
  //     minute: parseInt(strArr[1]),
  //     second: 0,
  //   };
  // }

  getFileName(imageUrl) {
    let fileNameLowerCase = imageUrl.split('/').pop().toLowerCase();
    this.fileName = fileNameLowerCase;
  }

  topicsObject() {
    const formTopic: any[] = this.createCourseForm.get('topics').value;
    this.topics.forEach((topic) => {
      formTopic.includes(topic.id), this.topicsObjectArray.push(topic);
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
